import { Component } from 'react';
import { Link } from 'react-router';
import Loading from '../../common/lib/Loading';
import type { MultiLang } from '../../config';
import Functions from '../../functions';
import CreditsUtils, { type CreditsMenuData } from '../lib/CreditsUtils';

interface Props {
    lang: MultiLang;
}

interface State {
    loading: boolean;
    menu: CreditsMenuData[];
}

class CreditsMenu extends Component<Props, State> {
    private isActive: boolean;

    constructor(props: Props) {
        super(props);
        this.isActive = false;
        this.state = {
            loading: true,
            menu: [],
        };
    }

    componentDidMount() {
        this.isActive = true;
        this.updateMenu();
    }

    componentWillUnmount() {
        this.isActive = false;
    }

    async updateMenu() {
        const menu = await CreditsUtils.getMenu();
        if (this.isActive) {
            this.setState({ loading: false, menu });
        }
    }

    render() {
        const { lang } = this.props;
        const { loading, menu } = this.state;
        if (loading) {
            return <Loading />;
        }
        return (
            <ul className="mainmenu">
                {menu.map((item, idx) => (
                    <li key={item.link}>
                        <Link className={idx === 0 ? 'menuTop' : 'menuMain'} to={item.link}>
                            {Functions.mlang(item.title, lang)}
                        </Link>
                    </li>
                ))}
            </ul>
        );
    }
}

export default CreditsMenu;
